import { render } from "./staff-edit-draw.vue?vue&type=template&id=d3617054&scoped=true"
import script from "./staff-edit-draw.vue?vue&type=script&lang=js"
export * from "./staff-edit-draw.vue?vue&type=script&lang=js"

import "./staff-edit-draw.vue?vue&type=style&index=0&id=d3617054&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3617054"]])

export default __exports__